import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';

import { FREE_SUBSCRIPTION_ROUTES, PUBLIC_ROUTES } from 'src/constants/routes';

import { useStyles } from './styles';

export const StartChecking = () => {
  const classes = useStyles();
  const isLogged = useSelector(state => state.user.isAuthenticated);

  const searchCompaniesPath = isLogged ? FREE_SUBSCRIPTION_ROUTES.ACCOUNT_COMPANIES : PUBLIC_ROUTES.REGISTER;
  const writeReviewPath = isLogged ? FREE_SUBSCRIPTION_ROUTES.ACCOUNT_WRITE_REVIEW_EMPTY : PUBLIC_ROUTES.REGISTER;

  return (
    <Box className={classes.container}>
      <Typography component="h2" className={classes.title}>
        Stop guessing. Start checking.
      </Typography>
      <Typography className={classes.description}>Search companies or leave a review to unlock access.</Typography>
      <Box className={classes.actions}>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          component={Link}
          to={searchCompaniesPath}
        >
          Search companies
        </Button>
        <Button variant="outlined" color="primary" className={classes.button} component={Link} to={writeReviewPath}>
          Write a review
        </Button>
      </Box>
    </Box>
  );
};
